class PassportClientError extends Error {
  constructor ({ code, message, httpStatusCode, subErrors }) {
    super(message)
    this.code = code
    this.httpStatusCode = httpStatusCode || 500
    this.subErrors = subErrors
  }
}

module.exports = PassportClientError



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chronobank/passport.client/lib/PassportClientError.js
// module id = K+8n
// module chunks = 0